export const ACCESS_TOKEN_KEY = "mbs_access_token";
export const ACCESS_TOKEN_EXPIRED_AT_KEY = "mbs_access_token_expired_at";
export const ACCESS_TOKEN_EXPIRED_TIME_KEY = "mbs_access_token_expired_time";
export const REFRESH_TOKEN_KEY = "mbs_refresh_token";
export const REFRESH_TOKEN_EXPIRED_AT_KEY = "mbs_refresh_token_expired_at";
export const REFRESH_TOKEN_EXPIRED_TIME_KEY = "mbs_refresh_token_expired_time";
